module.exports = __webpack_public_path__ + "img/num_42.df45d810.png";